import loadable from '@loadable/component';

/* NO AUTH PAGES */
const Login = loadable(() => import('./login'));
const Logout = loadable(() => import('./logout'));
const NotVerified = loadable(() => import('./notVerified'));
const Register = loadable(() => import('./register'));
const Offline = loadable(() => import('./offline'));
const Password = loadable(() => import('./password'));
const NotFound = loadable(() => import('./notFound'));

export { Login, Logout, NotVerified, Register, Offline, Password, NotFound };
